export * from './assign-supervised-rights.component';
